import { useRef } from 'react';
import { Button } from '../Button';
import { BgmSettings } from './BgmSettings';
import { SeSettings } from './SeSettings';
import { UserNameSettings } from './UserNameSettings';

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function SettingsModal({ isOpen, onClose }: SettingsModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 grid place-items-center z-20"
      role="presentation"
    >
      {/* オーバーレイ */}
      <div
        className="absolute inset-0 bg-black/50 z-[-1]"
        aria-hidden="true"
        onClick={onClose}
      />

      {/* モーダルコンテンツ */}
      <div
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby="settings-modal-title"
        className="grid place-items-center max-w-full z-10 md:max-w-600 h-full md:h-auto md:max-h-[90svh] overflow-y-auto bg-linear-to-br from-black via-gray-700 to-black p-24 md:p-48 rounded-xl overflow-clip"
      >
        <section className="grid gap-16 grid-cols-1 grid-auto-rows-max">
          <header className="flex items-center justify-between text-xl md:text-2xl">
            <h2 className="font-bold text-white">設定</h2>
            <Button
              onClick={onClose}
              aria-label="設定を閉じる"
              className="text-[0.8em]"
            >
              閉じる
            </Button>
          </header>
          <ul className="bg-white rounded-lg px-24 md:px-32 py-8 md:py-16 grid w-full">
            <li className="py-24 border-b-1 border-gray-200">
              <UserNameSettings />
            </li>
            <li className="py-24 border-b-1 border-gray-200">
              <BgmSettings />
            </li>
            <li className="py-24 border-b-1 border-gray-200">
              <SeSettings />
            </li>
            <li className="py-24 grid justify-center gap-16">
              <Button
                className="bg-linear-to-br from-red-800 via-red-500 to-red-800 text-white border-2 border-red-700"
                onClick={() => {
                  window.dispatchEvent(new CustomEvent('requestGameEnd'));
                  onClose?.();
                }}
              >
                ゲームを終了
              </Button>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
}
